import { Component } from 'react';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { InjectedFormProps, reduxForm } from 'redux-form';
import classNames from 'classnames';

import { FormField } from '../../../../forms/formField';
import {
    normalizeBankAccountNumber,
    normalizeSortCode
} from '../../../../helpers/normalizers';
import ConfirmationButton from '../../../ui/confirmationButton/ConfirmationButton';
import {
    REGISTER_BANK_ACCOUNT,
    REGISTER_DE_BANK_ACCOUNT
} from '../AddPaymentMethodModal.actions';
import messages from './LinkBankAccount.messages';
import styles from './LinkBankAccount.module.css';
import { validateBankDetails } from './formValidation/linkBankAccountFormValidationHandler';
import { getCountry } from '../../../../iwIntlProvider/CountryProvider';
import LinkDEBankAccountForm from './LinkDEBankAccount';
import { Dispatch } from 'redux';
import { RootState } from '@iwProvider/configureStore';
import { GetPaymentMethodResponse } from '@iwoca/lapi-client/v1';

type TBankDetails = NonNullable<
    GetPaymentMethodResponse['data']
>[number]['bank_details'];

const mapDispatchToProps = (dispatch: Dispatch) => ({
    addbankAccount: (bankAccountDetails: TBankDetails) =>
        dispatch({
            type:
                getCountry() === 'DE'
                    ? REGISTER_DE_BANK_ACCOUNT
                    : REGISTER_BANK_ACCOUNT,
            ...bankAccountDetails
        })
});

const mapStateToProps = ({
    addPaymentMethodModal,
    api
}: {
    addPaymentMethodModal: RootState['addPaymentMethodModal'];
    api: RootState['api'];
}) => ({
    ...addPaymentMethodModal,
    initialValues: {
        iban: _.find(api?.payment_method?.data, {
            payment_method_type: 'bank_account'
        })?.bank_details?.iban
    }
});

const formConfiguration = {
    form: 'linkBankAccount',
    validate: validateBankDetails,
    enableReinitialize: true
};

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

type TProps = {
    linkingBankAccount: boolean;
};

class LinkBankAccountForm extends Component<
    PropsFromRedux & TProps & InjectedFormProps
> {
    handleSubmit = (bankAccountDetails: TBankDetails) => {
        this.props.addbankAccount(bankAccountDetails);
    };

    renderLinkBankAccountFields() {
        if (_.includes(['DE'], getCountry())) {
            return <LinkDEBankAccountForm />;
        }
        return (
            <div
                className={styles.twoColumnWrapper}
                data-testid="link-bank-account-modal"
            >
                <FormField
                    name="accountNumber"
                    data-testid="account-number-input"
                    label={<FormattedMessage {...messages.accountNumber} />}
                    normalize={normalizeBankAccountNumber}
                    className={classNames(styles.accountNumber, 'fs-exclude')}
                />
                <FormField
                    name="sortCode"
                    data-testid="sortcode-input"
                    label={<FormattedMessage {...messages.sortCode} />}
                    normalize={normalizeSortCode}
                    className={classNames(styles.sortCode, 'fs-exclude')}
                />
            </div>
        );
    }

    render() {
        const {
            handleSubmit,
            linkingBankAccount,
            invalid,
            registerBankAccountStatus
        } = this.props;

        return (
            <form
                data-testid="link-bank-account-form"
                className={styles.LinkBankAccountForm}
                // @ts-expect-error
                onSubmit={handleSubmit(this.handleSubmit)}
            >
                {this.renderLinkBankAccountFields()}
                <div className={styles.submitWrapper}>
                    <ConfirmationButton
                        className={styles.save}
                        type="submit"
                        data-testid="link-bank-account-button"
                        status={registerBankAccountStatus}
                        loading={linkingBankAccount}
                        disabled={invalid}
                        onClick={this.handleSubmit}
                    >
                        <FormattedMessage {...messages.promptSave} />
                    </ConfirmationButton>
                </div>
            </form>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-expect-error
)(reduxForm(formConfiguration)(LinkBankAccountForm));
